var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.postData)?_c('article-post',_vm._b({},'article-post',_vm.postData,false),[_c('div',[_vm._v(" Turns out semicolon-less style is easier and safer in TS because most gotcha edge cases are type invalid as well. ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }